import React from 'react'

import styled from '@emotion/styled'
import { mq, grayBorder } from '../../../_style';

const Container = styled.div`
  margin: 60px 0 0;
  padding-top: 30px;
  border-top: 1px solid ${grayBorder};
  & > * {
    max-width: 304px;
    ${mq.sp} {
      margin: 0 auto;
    }
    & + * {
      margin-top: 34px;
    }
  }
`

export default class DetailBanners extends React.Component {
  render() {
    return(
      <Container>
        {this.props.children}
      </Container>
    )
  }
}
